import { state, props, resolveObject } from 'cerebral/tags'
import { unset, increment, when } from 'cerebral/operators'
import createSnackbar from 'modules/App/factories/createSnackbar'
import getFirstOrderId from '../actions/getFirstOrderId'
import loadOrderById from './loadOrderById'
import handleAttest from '../actions/handleAttest'

export default [
  handleAttest,
  when(state`orderHistory.detail`, detail => Object.keys(detail).length === 1),
  {
    true: [
      unset(state`orderHistory.history.${state`orderHistory.currentId`}`),
      unset(state`orderHistory.attestOrders.${state`orderHistory.currentId`}`),
      unset(state`orderHistory.currentId`),
      increment(state`orderHistory.count`, -1),
      createSnackbar(
        resolveObject({
          key: 'bms.orderHistory.orderAttested',
          params: resolveObject({ id: props`shortId` })
        })
      ),
      when(
        state`orderHistory.history`,
        history => Object.keys(history).length === 0
      ),
      {
        true: [unset(state`orderHistory.detail.${props`id`}`)],
        false: [getFirstOrderId, ...loadOrderById]
      }
    ],
    false: [unset(state`orderHistory.detail.${props`id`}`)]
  }
]



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/chains/onAttest.js